import { useState, useEffect } from "react";
import { Link } from "@tanstack/react-router";

const CONSENT_KEY = "forexmind_cookie_consent";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const persist = async (choice: "accepted" | "rejected") => {
    localStorage.setItem(CONSENT_KEY, choice);
    setVisible(false);
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      if (data.session?.user) {
        const { setCookieConsent } = await import("@/lib/consent.functions");
        await setCookieConsent({ data: { choice } });
      }
    } catch {
      /* anonymous visitor — localStorage is sufficient */
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] border-t border-border bg-card/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-4 sm:flex-row sm:px-6 lg:px-8">
        <p className="text-sm text-muted-foreground text-center sm:text-left">
          We use essential cookies to keep you signed in. Optional analytics cookies are off
          unless you accept. See our{" "}
          <Link
            to="/privacy"
            className="underline hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex shrink-0 flex-wrap gap-2 sm:gap-3">
          <button
            onClick={() => void persist("rejected")}
            className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent"
          >
            Reject non-essential
          </button>
          <button
            onClick={() => void persist("accepted")}
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
